import React from 'react'
import Select from 'react-select'

import { CustomControl, CustomValueContainer, DisableRender } from '@/legacy-src/components/filters/Filter'

import { getTranslate } from '../../utilities/i18n'
import useFilters from './hooks/useFilters'
import useSort from './hooks/useSort'
import { SORT_SLUG } from './sort.constants'

const defaultParam = 'retentionSort'
const sortParameters = [defaultParam, 'experience', 'recommendations', 'priceDesc', 'priceAsc']

const slug = SORT_SLUG

const sortOptions = (t) =>
  sortParameters.map((item) => {
    return {
      value: item,
      label: t(`therapistProfile.sortOptions.${item}`),
      desc: item !== 'priceAsc',
    }
  })

const Sort: React.FC = () => {
  const { t } = getTranslate()
  const { getFilterValue } = useFilters()
  const { setSortValues, resetSort } = useSort()

  const options = sortOptions(t)

  const defaultValue = { label: t(`therapistProfile.sortOptions.retentionSort`), value: defaultParam }
  const filterValues = getFilterValue(slug)
  const value = options.filter((option) => filterValues.includes('' + option.value))

  const handleOnChange = (newValue) => {
    if (newValue.value === defaultParam) {
      resetSort()
    } else {
      setSortValues(slug, newValue.value, newValue.desc)
    }
  }

  return (
    <Select
      className="react-select !max-w-none"
      classNamePrefix="react-select"
      isSearchable={false}
      isClearable={false}
      name={slug}
      noOptionsMessage={() => t('general.noOption', {}, { fallback: '' })}
      onChange={handleOnChange}
      options={options}
      value={value.length > 0 ? value : defaultValue}
      components={{ Control: CustomControl, ValueContainer: CustomValueContainer, IndicatorsContainer: DisableRender }}
      icon="up-down"
    />
  )
}

export default Sort
